export const courseEnrollmentMode = {
    standard: 1,
    supervised: 2,
    free: 4,
    password: 8
};

export const courseEnrollmentStatus = {
    approved: 1,
    pending: 2,
    notApproved: 3
};
